import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Helper as StatechartHelper } from "./Statechart.js";

const HistoryTable = styled.table`
	width: 100%;

	span.choice {
		display: inline-block;
		margin-right: 1em;
		color: #ccc;

		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}

		&.chosen {
			color: #333;
			text-decoration: underline;
		}
	}
`;

class HistoryView extends Component {
	static contextTypes = {
		copy: PropTypes.object,
	};
	static propTypes = {
		reverse: PropTypes.bool.isRequired,
		history: PropTypes.array.isRequired,
		revertTo: PropTypes.func.isRequired,
		dispatch: PropTypes.func.isRequired,
	};
	static defaultProps = {
		reverse: false,
	};
	onHistoricalChoiceClick = (trigger, historyItem, historyItemIndex) => {
		const { reverse, history, revertTo, dispatch } = this.props;
		if (historyItem.choice != null) {
			if (historyItem.choice === trigger) {
				// do nothing
			} else {
				const index = reverse
					? history.length - historyItemIndex - 1
					: historyItemIndex;
				revertTo(index, () => {
					dispatch({ type: trigger });
				});
			}
		} else {
			dispatch({ type: trigger });
		}
	};
	historyItem = (historyItem, historyItemIndex) => {
		const copy = this.context.copy;
		const content = copy.getContent(historyItem.state);
		return (
			<tr key={`${historyItemIndex}-${historyItem.state.value}`}>
				<td>{content.title || historyItem.state.value}</td>
				<td>
					{StatechartHelper.getAvailableTriggers(
						historyItem.state
					).map(trigger => (
						<span
							key={`${historyItemIndex}_${trigger}`}
							className={
								historyItem.choice === trigger
									? "choice chosen"
									: "choice"
							}
							onClick={() => {
								this.onHistoricalChoiceClick(
									trigger,
									historyItem,
									historyItemIndex
								);
							}}
						>
							{copy.getTriggerName(historyItem.state, trigger)}
						</span>
					))}
				</td>
			</tr>
		);
	};
	render() {
		const history = [...this.props.history];
		if (this.props.reverse) {
			history.reverse();
		}
		return (
			<section>
				<h4>History</h4>
				<HistoryTable>
					<tbody>
						<tr>
							<th>State Title</th>
							<th>Choices</th>
						</tr>
						{history.map(this.historyItem)}
					</tbody>
				</HistoryTable>
			</section>
		);
	}
}

export default HistoryView;



// WEBPACK FOOTER //
// ./src/Wizard/HistoryView.js